import {
    IComponentConfig,
    IComponentDefinitionConfig,
    IComponentInstanceConfig, IHTMLLoaderConfig, IRefConfig,
    ISkinLoaderConfig,
    ISkinSelectorConfig,
    IDedicatedSkinConfig, ISkinConfig
} from "../common";
import {uuidv4} from "../utils/utils.ts";

export class SkinConfig implements ISkinConfig {
    _runTimeInstanceId = 'runtime-instance-id-' + uuidv4();
    _runTimeId = 'runtime-id-' + uuidv4();
    _runTimeName = 'runtime-name-' + uuidv4();

    static create = () => {
        return new SkinConfig();
    }

    id = this._runTimeId;
    name = this._runTimeName;
    description = '';
    loader = null as unknown as ISkinLoaderConfig;

    withLoader = (loader: ISkinLoaderConfig) => {
        this.loader = loader;
        return this;
    }

    withHTMLLoader = (loader: Omit<IHTMLLoaderConfig, 'type'>) => {
        loader.type = 'HTMLLoader';
        this.loader = loader as IHTMLLoaderConfig;
        return this;
    }

    build = () => {
        return this;
    }
}

export class ComponentConfig implements IComponentConfig {
    _runTimeInstanceId = 'runtime-instance-id-' + uuidv4();
    _runTimeId = 'runtime-id-' + uuidv4();
    _runTimeName = 'runtime-name-' + uuidv4();

    static create = () => {
        return new ComponentConfig();
    }

    instance = {
        id: this._runTimeInstanceId,
        componentId: this._runTimeId,
        componentName: this._runTimeName,
        skinSelector: null as unknown as ISkinSelectorConfig
    } as IComponentInstanceConfig;

    name = this._runTimeName
    type = {
        id: this._runTimeId,
        name: this._runTimeName,
        description: '',
        props: [],
        refs: [],
        skins: [],
        defaultSkin: 0
    } as IComponentDefinitionConfig

    withInstance = (instance: IComponentInstanceConfig) => {
        this.instance = instance;
        return this;
    }

    withType = (type: IComponentDefinitionConfig) => {
        this.type = type;
        return this;
    }

    withName = (name: string) => {
        this.name = name;
        return this;
    }

    withDefaultSkin = (defaultSkin: ISkinConfig) => {
        this.type.skins.push(defaultSkin);
        this.type.defaultSkin = this.type.skins.length - 1;
        this.instance.skinSelector = {
            type: 'Dedicated',
            skin: {
                id: defaultSkin.id
            }
        } as IDedicatedSkinConfig

        return this;
    }

    withRef = (ref: IRefConfig) => {
        this.type.refs.push(ref);
        return this;
    }

    withBasicRef = (refSelector: string) => {
        const newBasicRef = {
            id: '',
            name: refSelector,
            description: '',
            selectorType: 'id-attribute',
            selector: refSelector,
            behavior: {
                type: 'code'
            }
        } as IRefConfig

        this.type.refs.push(newBasicRef);
        return this;
    }

    build = () => {
        return JSON.parse(JSON.stringify(this))
    }
}
